import { z } from 'zod/v4';

import { addressSchema } from '../../../schemas/address.schema';
import { coercedDate } from '../../../utils/coerced-date';

export const placeSchema = z.object({
  trimblePlaceId: z.string(),
  customPlaceId: z.string().nullable(),
  name: z.string(),
  setId: z.number().optional(),
  categoryName: z.string().nullable(),
  address: addressSchema.omit({ streetName: true }),
  formattedAddress: z.string(),
  geometry: z.object({
    type: z.enum(['Point']),
    coordinates: z.array(z.number()),
  }),
  region: z.string(),
  placeClassification: z.enum(['Basic', 'Premium', 'Private']),
  lastModified: coercedDate,
});

export type Place = z.infer<typeof placeSchema>;
